import { Route, Routes } from 'react-router-dom';
import { MARKETPLACE_MANAGEMENT_PATHS } from '../constants/routePaths';
import Listing from '../pages/admin-marketplace/listing/Listing';
import MarketplaceSettings from '../pages/admin-marketplace/marketplace-settings/MarketplaceSettings';
import CommissionReport from '../pages/admin-marketplace/commission-report/CommissionReport';
import BreederPayments from '../pages/admin-marketplace/breeder-payments';

const MarketplaceManagementRoutes = () => {
  return (
    <div>
      <Routes>
        <Route path={MARKETPLACE_MANAGEMENT_PATHS.LISTING} element={<Listing />} />
        <Route path={MARKETPLACE_MANAGEMENT_PATHS.SETTINGS} element={<MarketplaceSettings />} />
        <Route path={MARKETPLACE_MANAGEMENT_PATHS.COMMISSION_REPORT} element={<CommissionReport />} />
        <Route path={MARKETPLACE_MANAGEMENT_PATHS.BREEDER_PAYMENTS} element={<BreederPayments />} />
      </Routes>
    </div>
  );
};

export default MarketplaceManagementRoutes;
